import { type ApiContainerAction, type ApiOrderPosition, EnumContainerOrderAction } from '@Model';

/** The container action a position's material comes from, as the positions table names it. */
export type PositionOrigin = 'aus Abholen' | 'aus Leeren' | 'aus Tausch';

/** Which pickup, emptying or swap carries the position's material; only the first position of a material is named. */
// @ai-generated 2026-10-15T12:08:29+00:00 by malte.ulfers@tngtech.com using Claude Opus 5.5 (1M context)
export function positionOriginOf(
    position: ApiOrderPosition,
    positions: readonly ApiOrderPosition[],
    actions: readonly ApiContainerAction[],
): PositionOrigin | undefined {
    const material = position.service.foreign_key;
    const first = positions.find((other) => other.service.foreign_key === material);

    if (first !== undefined && first.id !== position.id) {
        return undefined;
    }

    const carrier = actions.find(
        (action) =>
            !!material && action.action !== EnumContainerOrderAction.Place && action.content.foreign_key === material,
    );

    if (carrier === undefined) {
        return undefined;
    }

    if (carrier.exchange_id) {
        return 'aus Tausch';
    }

    return carrier.action === EnumContainerOrderAction.Empty ? 'aus Leeren' : 'aus Abholen';
}
